export interface FileValidationOptions {
  allowedExtensions?: string[];
  allowedMimeTypes?: string[];
  maxSizeMB?: number;
}

export type FileValidationError =
  | { kind: "format"; formats: string }
  | { kind: "size"; size: number };

export const getFileExtension = (fileName: string): string =>
  fileName.split(".").pop()?.toLowerCase()?.trim() || "";

export const validateUploadFile = (
  file: File | undefined,
  options: FileValidationOptions
): FileValidationError | null => {
  if (!file) return null;

  const { allowedExtensions, allowedMimeTypes, maxSizeMB } = options;

  if (allowedExtensions && allowedExtensions.length > 0) {
    const ext = getFileExtension(file.name);
    if (!allowedExtensions.map((e) => e.toLowerCase()).includes(ext)) {
      return {
        kind: "format",
        formats: allowedExtensions.map((e) => `.${e}`).join(", "),
      };
    }
  }

  if (allowedMimeTypes && allowedMimeTypes.length > 0 && file.type) {
    if (!allowedMimeTypes.includes(file.type)) {
      return {
        kind: "format",
        formats: allowedExtensions
          ? allowedExtensions.map((e) => `.${e}`).join(", ")
          : allowedMimeTypes.join(", "),
      };
    }
  }

  if (maxSizeMB !== undefined && file.size > maxSizeMB * 1024 * 1024) {
    return { kind: "size", size: maxSizeMB };
  }

  return null;
};

export const translateFileValidationError = (
  t: (key: any, options?: Record<string, unknown>) => string,
  error: FileValidationError,
  fallback?: string
): string => {
  if (error.kind === "format") {
    return (
      t("error-file-invalid-format", { formats: error.formats }) ||
      fallback ||
      `Invalid file format. Allowed: ${error.formats}`
    );
  }
  return (
    t("error-file-max-size", { size: error.size }) ||
    fallback ||
    `File size exceeds ${error.size}MB`
  );
};

export const DOCUMENT_UPLOAD_OPTIONS: FileValidationOptions = {
  allowedExtensions: ["jpg", "jpeg", "png", "pdf"],
  maxSizeMB: 4,
};

export const IMAGE_UPLOAD_OPTIONS: FileValidationOptions = {
  allowedExtensions: ["jpg", "jpeg", "png"],
  allowedMimeTypes: ["image/jpeg", "image/png", "image/jpg"],
  maxSizeMB: 2,
};

export const FLEET_PICTURE_OPTIONS: FileValidationOptions = {
  allowedExtensions: ["jpg", "jpeg", "png"],
  maxSizeMB: 5,
};
